// JavaScript source code

$(document).ready(function () {
  
	new fullpage('.seo-slider', {
    licenseKey: '6C9029BF-AD0B4A3B-92171818-D07E7657',
    anchors:['slide-1', 'slide-2', 'slide-3', 'slide-4', 'slide-5'],
    responsiveWidth: 1280,
    navigation: true,
    afterLoad: function(origin, destination, direction){
      $('.section.active').find('.animate').addClass('popIn');
    }
  });

  new fullpage('.page-slider',  {
    licenseKey: '6C9029BF-AD0B4A3B-92171818-D07E7657',
    anchors:['top-section', 'middle-section', 'bottom-section', 'recommended-section'],
    responsiveWidth: 1280,
    navigation: true,
    afterLoad: function(origin, destination, direction){
      $('.section.active').find('.animate').addClass('popIn');
    }
  });
  
  new fullpage('.work-page', {
    licenseKey: '6C9029BF-AD0B4A3B-92171818-D07E7657',
    anchors:['slide-1', 'slide-2', 'slide-3', 'slide-4', 'slide-5', 'slide-6', 'slide-7'],
    responsiveWidth: 1280,
    navigation: true,
     afterLoad: function(origin, destination, direction){
      $('.work-page-slide.active').find('.animate').addClass('popIn');
    }
  });
  
  if ($(window).width() <= 1024) {
    $(".key-message.desktop").remove()
  }
  else {
  	$(".key-message.mobile").remove()
  }
  
  if ($(".success-text").length > 0) {
    $(".contact-page .section-header, .contact-page .description").hide();
  }

  menuPopup();
  setMaxHeightOnMobile(".menu-sublist");
});

$(window).on('resize', function() {
  setMaxHeightOnMobile(".menu-sublist");
});

function menuPopup() {
  $(".menu-sublist").detach().prependTo(".page-container");
  $('.menu-title').click(function () {
    $(".menu-sublist").toggleClass("open");
  });
  $('.menu-close').click(function () {
    $(this).parent(".menu-sublist").removeClass("open");
  });
}

function setMaxHeightOnMobile(element, additionalHeight) {

  if (typeof additionalHeight === 'string') {

    additionalHeight = $(additionalHeight).outerHeight();

  } else if (typeof additionalHeight === 'undefined') {

    additionalHeight = 0;

  }

  if ($(window).width() <= 1024) {

    $(element).css('max-height', $(window).height() - additionalHeight);

  }
  else {
    $(element).removeAttr('style');
  }
}


/*SLICK*/
$(document).ready(function () {
  $('.sherpas-slider').slick({
    dots: true,
  });
  
  $('.recommended-slider').slick({
    dots: true,
    autoplay: true,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 1320,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: true
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: true
      }
    }
  ]
  });
  
});
/*END OF SLICK*/